import React, { useEffect } from "react";
import { buildingStore } from "store/Building/BuildingStore";
import { useParams } from "react-router";
import BuildingsList from "../components/BuildingsList";
import { observer } from "mobx-react-lite";
import useSidebarMenu from "../useSidebarMenu";
import { organisationStore } from "features/Organisation/OrganisationStore";

function SharedBuildingsList() {
  const { sharedBuildings: buildings, currentBuilding } = buildingStore;
  const { id } = useParams();
  const { openLastEditedSharedBuilding, saveLastEditedSharedBuilding } =
    useSidebarMenu();

  useEffect(() => {
    const current = buildings.items.find((item) => item.building.id === id);
    if (current && !currentBuilding)
      buildingStore.setCurrentBuilding(current.building);
  }, [buildings]);

  useEffect(() => {
    if (organisationStore.organisations.items.length === 0) return;
    openLastEditedSharedBuilding();
  }, []);

  return (
    <BuildingsList
      buildings={buildings.items.map((item) => item.building)}
      loading={buildings.loading}
      onClickBuilding={saveLastEditedSharedBuilding}
      containerClassName="pt-3"
    />
  );
}

export default observer(SharedBuildingsList);
